import React from 'react'

import { reduce, isString, isArray, keyBy, identity, get } from 'lodash'

import InternalContext from './context'

export default (config) => {
  let workingConfig = config
  if (isString(workingConfig)) {
    workingConfig = [workingConfig]
  }
  if (isArray(workingConfig)) {
    workingConfig = keyBy(workingConfig, identity)
  }
  const mapValueViaConfig = (context) =>
    reduce(
      workingConfig,
      (result, propField, contextField) => {
        result[propField] = get(context, contextField)
        return result
      },
      {},
    )
  return (WrappedComponent) => {
    const HoC = (props) => (
      <InternalContext.Consumer>
        {(value) => (
          <WrappedComponent
            {...mapValueViaConfig(value)}
            {...props}
          />
        )}
      </InternalContext.Consumer>
    )
    HoC.displayName = `RealtimeMessagingContext(${WrappedComponent.displayName || WrappedComponent.name})`
    return HoC
  }
}
